import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInducedFlowAirCooler = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 92.8,
	height: 30,
	viewBox: "0 0 92.8 30.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 15,
			width: 70,
			height: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 35.0 10.0 L 59.0 4.0 A 3.0 3.0 0.0 1 1 59.0 10.0 L 35.0 4.0 A 3.0 3.0 0.0 1 0 35.0 10.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 22.0 30.0 L 22.0 15.0 L 27.0 0.0 M 72.0 30.0 L 72.0 15.0 L 67.0 0.0 M 0.0 22.5 L 92.8 22.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgInducedFlowAirCooler;
